// effects/city.effects.ts

import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators'
import { CityService } from '../../services/city.service'
import { loadCities, loadCitiesSuccess, loadFailure } from './city.actions'

export const loadCities$ = createEffect(
  (actions$ = inject(Actions), cityService = inject(CityService)) =>
    actions$.pipe(
      ofType(loadCities),
      switchMap(({ stateId }) =>
        cityService.getCitiesByState(stateId).pipe(
          map(cities => loadCitiesSuccess({ cities })),
          catchError(error => of(loadFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const cityEffects = {
  loadCities$
}
